/**
 * Get accumulated protocol fees for a market
 */
import type { Address } from "viem"
import { type ReadableClient, readAccruedProtocolFees } from "../../internal/contracts"
import { fromUsdcScale } from "../../internal/convert"
import type { AccumulatedFees } from "../../types"

export interface GetFeesParams {
	market: Address
}

/**
 * Get accumulated protocol fees for a market
 *
 * @example
 * ```ts
 * import { getFees } from "@breakout/sdk/actions/read"
 *
 * const fees = await getFees(publicClient, { market: "0x..." })
 * console.log(fees.protocol) // 150.00 - protocol fees in USDC
 * ```
 */
export async function getFees(
	client: ReadableClient,
	params: GetFeesParams,
): Promise<AccumulatedFees> {
	const raw = await readAccruedProtocolFees(client, params.market)

	return {
		protocol: fromUsdcScale(raw),
	}
}
